export const timeseriesChartTypes = [
  { label: 'Lines', value: 'LineChart' },
  { label: 'Stacked Area', value: 'AreaChart' },
  { label: 'Bars', value: 'ColumnChart' },
];
